module.exports = __webpack_public_path__ + "img/grow-your-contact-list.3bcbaa4b.png";